<template>
  <v-card :color="statusColor.card">
    <v-container class="pa-0">
      <v-row dense>
        <v-col cols="4" align-center class="text-center pa-6"
          ><v-icon :size="icon.size + 16" :color="statusColor.icon">
            {{ icon.symbol }}
          </v-icon>
          <v-card-text
            class="text-body-2"
            :class="textColor"
            v-if="!$vuetify.breakpoint.mobile"
            >{{ stage.comment }}
          </v-card-text></v-col
        >
        <v-col cols="8" class="pa-3">
          <v-card-title class="headline" :class="textColor">
            {{ name }}
          </v-card-title>
          <v-card-subtitle class="text-subtitle-2" :class="textColor">
            <p>{{ areaInStage(stage) }}</p>
            <span class="text-title">{{ effective }}</span>
          </v-card-subtitle>
          <v-card-text
            class="text-body-1"
            :class="textColor"
            v-if="$vuetify.breakpoint.mobile"
            >{{ stage.comment }}
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { statusIcon } from '@/components/requests/status/statusIconModel'
import { formattedDateTime } from '@/micro/time/dateFormat'

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    editedItem: {
      type: Object,
      required: true
    },
    stage: {
      type: Object,
      required: true
    },
    statusOf: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters('assignments', ['areaInStage']),
    ...mapGetters('workflows', ['statusColorByStage']),
    icon() {
      return this.statusIcon(this.stage.id, this.stage.status)
    },
    statusColor() {
      return this.statusColorByStage(
        this.stage,
        this.statusOf(this.stage, this.editedItem),
        this.editedItem
      )
    },
    textColor() {
      const parts = this.statusColor.text.split(' ')
      return `${parts[0]}--text text--${parts[1]}`
    },
    effective() {
      return formattedDateTime(this.stage.effective)
    },
    name() {
      const checkin = {
        request: 'Ingresé',
        auth: 'Ingresó'
      }
      const checkout = {
        request: 'Salí',
        auth: 'Salió'
      }
      return this.stage.id === 'checkin'
        ? checkin[this.type]
        : checkout[this.type]
    }
  },
  methods: {
    statusIcon
  }
}
</script>
